import React, { useState } from 'react';
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import useTranslation from 'Hooks/useTranslation';
import MultiSelectInput from '../MultiSelectInput';
import { FormContainer, SelectContainer } from './style';

function PrivateLessonForm({
  users,
  privateUsers,
  selectHandler,
  isPrivate,
  setIsPrivate,
  enrolledUsers,
  setUnchanged,
}) {
  const [showInput, setShowInput] = useState(isPrivate);
  const { t2 } = useTranslation('EditCourse');

  const handleCheckbox = () => {
    setShowInput(!showInput);
    setIsPrivate(!showInput);
    setUnchanged(false);
  };

  return (
    <FormContainer>
      <FormGroup>
        <FormControlLabel
          onChange={handleCheckbox}
          control={
            <Checkbox color="success" checked={isPrivate !== null ? isPrivate : false} onChange={handleCheckbox} />
          }
          label={`${t2('PrivateLesson')} ?`}
        />
        <FormHelperText>{t2('PrivateLessonInfo')}</FormHelperText>
      </FormGroup>
      {showInput && users.length > 0 && (
        <SelectContainer>
          <MultiSelectInput
            name="users"
            data={users}
            selected={privateUsers || []}
            onChange={array => {
              selectHandler(array);
            }}
            placeHolderText={t2('Members')}
          />
        </SelectContainer>
      )}
      {enrolledUsers.length > 0 && users && showInput && (
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>{t2('PrivateLessonEnrolled')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {enrolledUsers.map(user => (
              <Typography key={user.id}>{user.fullName}</Typography>
            ))}
          </AccordionDetails>
        </Accordion>
      )}
    </FormContainer>
  );
}

export default PrivateLessonForm;
